
angular.module('bmsApp.directives').factory('PhotoSvc', [
	'$rootScope',
	'CRUDSvc',
	'PHOTO_API', function (
		$rootScope,
		CRUDSvc,
		PHOTO_API) {

	return {
		indexByObject: function (params) {
			return CRUDSvc.post(PHOTO_API.INDEX_BY_OBJECT, params);
		},
	};

}]).constant('PHOTO_API', {
	INDEX_BY_OBJECT: 'api/photo/indexByObject',
});
